
























































































































































































































import { Component, Vue } from "vue-property-decorator";
import QErrors from "@/common/qErrors.vue";
import StepCheckList from "@/components/contract-moving/step/stepCheckList.vue";
import ContractMoveOutHistory from "@/components/contract-moving/contractMoveOutHistory.vue";
import { namespace } from "vuex-class";
import ContractMoveOut from "@/model/contractMoveOut";
import _ from "lodash";
import Company from "@/model/company";
import QUserSelect from "@/common/qUserSelect.vue";
import QCalendar from "@/common/qCalendar.vue";
import ReportRepair from "@/components/contract-moving/reportRepair.vue";

const moveOutStore = namespace("MoveOut");
const auth = namespace("Auth");
@Component({
  name: "StepCorrectCheckList",
  components: {
    StepCheckList,
    QErrors,
    ContractMoveOutHistory,
    QUserSelect,
    QCalendar,
    ReportRepair,
  },
})
export default class StepCorrectCheckList extends Vue {
  @moveOutStore.Getter
  getMoveOut!: ContractMoveOut;
  @auth.Getter
  getCurrentyCompany!: Company;

  public moveOutObject: ContractMoveOut = new ContractMoveOut();
  public errors = {};

  mounted() {
    this.moveOutObject = new ContractMoveOut(_.cloneDeep(this.getMoveOut));
    console.log(this.moveOutObject);
  }
}
